// Trivial classnames join, matching ui/src/lib/utils/cn.ts's contract
// closely enough for ATFLogo's usage (falsy values filtered, arrays not
// needed here). Not pulling in clsx as a new dependency for one helper.
export type ClassValue = string | number | boolean | null | undefined

export function cn(...inputs: ClassValue[]): string {
  return inputs.filter(Boolean).join(' ')
}
